module.exports = __webpack_public_path__ + "img/germany-cerebrovascular-disease-male.68c8194d.png";